import { C_BUSINESS_DETAILS_ID } from "./bussines-detail";

export const C_BUSINESS_TYPE_ID = {
  SALE: 1,
  RENT: 2,
  RENT_FURNISHED: 3,
  SALE_AND_RENT: 4,
  SALE_FURNISHED: 5,
  WHITE_LINE_RENTAL: 6,
  WHITE_LINE_SALES: 7,
  SALE_AND_FURNISHED_RENTAL: 8,
  SALE_AND_RENTAL_OF_WHITE_GOODS: 9
};

export const C_BUSINESS_TYPE_ALL = {
  SALE: {
    name: "Venta",
    id: C_BUSINESS_TYPE_ID.SALE,
    value: "sale",
    label: "Venta",
    combine: {
      business: C_BUSINESS_TYPE_ID.SALE,
      detail: C_BUSINESS_DETAILS_ID.NONE
    },
    extra: {
      saleLabel: "Venta",
      rentLabel: "",
      detailLabel: ""
    }
  },
  RENT: {
    name: "Alquiler",
    id: C_BUSINESS_TYPE_ID.RENT,
    value: "lease",
    label: "Alquiler",
    combine: {
      business: C_BUSINESS_TYPE_ID.RENT,
      detail: C_BUSINESS_DETAILS_ID.NONE
    },
    extra: {
      saleLabel: "",
      rentLabel: "Alquiler",
      detailLabel: ""
    }
  },
  RENT_FURNISHED: {
    name: "Alquiler Amueblado",
    id: C_BUSINESS_TYPE_ID.RENT_FURNISHED,
    value: "rentFurnished",
    label: "Alquiler Amueblado",
    combine: {
      business: C_BUSINESS_TYPE_ID.RENT,
      detail: C_BUSINESS_DETAILS_ID.FURNISHED
    },
    extra: {
      saleLabel: "",
      rentLabel: "Alquiler",
      detailLabel: "Amueblado"
    }
  },
  SALE_AND_RENT: {
    name: "Venta y Alquiler",
    id: C_BUSINESS_TYPE_ID.SALE_AND_RENT,
    value: "saleOrLease",
    label: "Venta y Alquiler",
    combine: {
      business: C_BUSINESS_TYPE_ID.SALE_AND_RENT,
      detail: C_BUSINESS_DETAILS_ID.NONE
    },
    extra: {
      saleLabel: "Venta",
      rentLabel: "Alquiler",
      detailLabel: ""
    }
  },
  SALE_FURNISHED: {
    name: "Venta Amueblado",
    id: C_BUSINESS_TYPE_ID.SALE_FURNISHED,
    value: "saleFurnished",
    label: "Venta Amueblado",
    combine: {
      business: C_BUSINESS_TYPE_ID.SALE,
      detail: C_BUSINESS_DETAILS_ID.FURNISHED
    },
    extra: {
      saleLabel: "Venta",
      rentLabel: "",
      detailLabel: "Amueblado"
    }
  },
  WHITE_LINE_RENTAL: {
    name: "Alquiler Linea Blanca",
    id: C_BUSINESS_TYPE_ID.WHITE_LINE_RENTAL,
    value: "whiteLineRental",
    label: "Alquiler Linea Blanca",
    combine: {
      business: C_BUSINESS_TYPE_ID.RENT,
      detail: C_BUSINESS_DETAILS_ID.WHITES
    },
    extra: {
      saleLabel: "",
      rentLabel: "Alquiler",
      detailLabel: "Linea Blanca"
    }
  },
  WHITE_LINE_SALES: {
    name: "Venta Linea Blanca",
    id: C_BUSINESS_TYPE_ID.WHITE_LINE_SALES,
    value: "whiteLineSales",
    label: "Venta Linea Blanca",
    combine: {
      business: C_BUSINESS_TYPE_ID.SALE,
      detail: C_BUSINESS_DETAILS_ID.WHITES
    },
    extra: {
      saleLabel: "Venta",
      rentLabel: "",
      detailLabel: "Linea Blanca"
    }
  },
  SALE_AND_FURNISHED_RENTAL: {
    name: "Venta y alquiler amueblado",
    id: C_BUSINESS_TYPE_ID.SALE_AND_FURNISHED_RENTAL,
    value: "saleAndFurnishedRental",
    label: "Venta y alquiler amueblado",
    combine: {
      business: C_BUSINESS_TYPE_ID.SALE_AND_RENT,
      detail: C_BUSINESS_DETAILS_ID.FURNISHED
    },
    extra: {
      saleLabel: "Venta",
      rentLabel: "Alquiler",
      detailLabel: "Amueblado"
    }
  },
  SALE_AND_RENTAL_OF_WHITE_GOODS: {
    name: "Venta y alquiler línea blanca",
    id: C_BUSINESS_TYPE_ID.SALE_AND_RENTAL_OF_WHITE_GOODS,
    value: "saleAndRentalOfWhiteGoods",
    label: "Venta y alquiler línea blanca",
    combine: {
      business: C_BUSINESS_TYPE_ID.SALE_AND_RENT,
      detail: C_BUSINESS_DETAILS_ID.WHITES
    },
    extra: {
      saleLabel: "Venta",
      rentLabel: "Alquiler",
      detailLabel: "Línea blanca"
    }
  }
};
const {
  SALE,
  RENT,
  SALE_AND_RENT,
  RENT_FURNISHED,
  SALE_AND_FURNISHED_RENTAL,
  SALE_AND_RENTAL_OF_WHITE_GOODS,
  SALE_FURNISHED,
  WHITE_LINE_RENTAL,
  WHITE_LINE_SALES
} = C_BUSINESS_TYPE_ALL;

export const C_BUSINESS_TYPE = {
  SALE,
  SELL: RENT,
  SALE_AND_SELL: SALE_AND_RENT,
  RENT_FURNISHED,
  SALE_AND_FURNISHED_RENTAL,
  SALE_AND_RENTAL_OF_WHITE_GOODS,
  SALE_FURNISHED,
  WHITE_LINE_RENTAL,
  WHITE_LINE_SALES
};

export const O_BUSINESS_TYPE = {
  [C_BUSINESS_TYPE.SALE.id]: C_BUSINESS_TYPE.SALE,
  [C_BUSINESS_TYPE.SELL.id]: C_BUSINESS_TYPE.SELL,
  [C_BUSINESS_TYPE.SALE_AND_SELL.id]: C_BUSINESS_TYPE.SALE_AND_SELL,
  [C_BUSINESS_TYPE.RENT_FURNISHED.id]: C_BUSINESS_TYPE.RENT_FURNISHED,
  [C_BUSINESS_TYPE.SALE_AND_FURNISHED_RENTAL.id]:
    C_BUSINESS_TYPE.SALE_AND_FURNISHED_RENTAL,
  [C_BUSINESS_TYPE.SALE_AND_RENTAL_OF_WHITE_GOODS.id]:
    C_BUSINESS_TYPE.SALE_AND_RENTAL_OF_WHITE_GOODS,
  [C_BUSINESS_TYPE.SALE_FURNISHED.id]: C_BUSINESS_TYPE.SALE_FURNISHED,
  [C_BUSINESS_TYPE.WHITE_LINE_RENTAL.id]: C_BUSINESS_TYPE.WHITE_LINE_RENTAL,
  [C_BUSINESS_TYPE.WHITE_LINE_SALES.id]: C_BUSINESS_TYPE.WHITE_LINE_SALES,

  [C_BUSINESS_TYPE.SALE.value]: C_BUSINESS_TYPE.SALE,
  [C_BUSINESS_TYPE.SELL.value]: C_BUSINESS_TYPE.SELL,
  [C_BUSINESS_TYPE.SALE_AND_SELL.value]: C_BUSINESS_TYPE.SALE_AND_SELL,
  [C_BUSINESS_TYPE.RENT_FURNISHED.value]: C_BUSINESS_TYPE.RENT_FURNISHED,
  [C_BUSINESS_TYPE.SALE_AND_FURNISHED_RENTAL.value]:
    C_BUSINESS_TYPE.SALE_AND_FURNISHED_RENTAL,
  [C_BUSINESS_TYPE.SALE_AND_RENTAL_OF_WHITE_GOODS.value]:
    C_BUSINESS_TYPE.SALE_AND_RENTAL_OF_WHITE_GOODS,
  [C_BUSINESS_TYPE.SALE_FURNISHED.value]: C_BUSINESS_TYPE.SALE_FURNISHED,
  [C_BUSINESS_TYPE.WHITE_LINE_RENTAL.value]: C_BUSINESS_TYPE.WHITE_LINE_RENTAL,
  [C_BUSINESS_TYPE.WHITE_LINE_SALES.value]: C_BUSINESS_TYPE.WHITE_LINE_SALES,

  //name
  [C_BUSINESS_TYPE.SALE.name]: C_BUSINESS_TYPE.SALE,
  [C_BUSINESS_TYPE.SELL.name]: C_BUSINESS_TYPE.SELL,
  [C_BUSINESS_TYPE.SALE_AND_SELL.name]: C_BUSINESS_TYPE.SALE_AND_SELL,
  [C_BUSINESS_TYPE.RENT_FURNISHED.name]: C_BUSINESS_TYPE.RENT_FURNISHED,
  [C_BUSINESS_TYPE.SALE_AND_FURNISHED_RENTAL.name]:
    C_BUSINESS_TYPE.SALE_AND_FURNISHED_RENTAL,
  [C_BUSINESS_TYPE.SALE_AND_RENTAL_OF_WHITE_GOODS.name]:
    C_BUSINESS_TYPE.SALE_AND_RENTAL_OF_WHITE_GOODS,
  [C_BUSINESS_TYPE.SALE_FURNISHED.name]: C_BUSINESS_TYPE.SALE_FURNISHED,
  [C_BUSINESS_TYPE.WHITE_LINE_RENTAL.name]: C_BUSINESS_TYPE.WHITE_LINE_RENTAL,
  [C_BUSINESS_TYPE.WHITE_LINE_SALES.name]: C_BUSINESS_TYPE.WHITE_LINE_SALES,

  // name lowercase
  [C_BUSINESS_TYPE.SALE.name.toLowerCase()]: C_BUSINESS_TYPE.SALE,
  [C_BUSINESS_TYPE.SELL.name.toLowerCase()]: C_BUSINESS_TYPE.SELL,
  [C_BUSINESS_TYPE.SALE_AND_SELL.name.toLowerCase()]: C_BUSINESS_TYPE.SALE_AND_SELL,
  [C_BUSINESS_TYPE.RENT_FURNISHED.name.toLowerCase()]:
    C_BUSINESS_TYPE.RENT_FURNISHED,
  [C_BUSINESS_TYPE.SALE_AND_FURNISHED_RENTAL.name.toLowerCase()]:
    C_BUSINESS_TYPE.SALE_AND_FURNISHED_RENTAL,
  [C_BUSINESS_TYPE.SALE_AND_RENTAL_OF_WHITE_GOODS.name.toLowerCase()]:
    C_BUSINESS_TYPE.SALE_AND_RENTAL_OF_WHITE_GOODS,
  [C_BUSINESS_TYPE.SALE_FURNISHED.name.toLowerCase()]:
    C_BUSINESS_TYPE.SALE_FURNISHED,
  [C_BUSINESS_TYPE.WHITE_LINE_RENTAL.name.toLowerCase()]:
    C_BUSINESS_TYPE.WHITE_LINE_RENTAL,
  [C_BUSINESS_TYPE.WHITE_LINE_SALES.name.toLowerCase()]:
    C_BUSINESS_TYPE.WHITE_LINE_SALES

  // value lowercase
};

export const A_BUSINESS_TYPE = [
  C_BUSINESS_TYPE.SALE,
  C_BUSINESS_TYPE.SELL,
  C_BUSINESS_TYPE.SALE_AND_SELL
];

export const A_BUSINESS_TYPE_PROJECT = [
  C_BUSINESS_TYPE.SALE,
];
